<footer class="footer border-top">
  <div
    class="container d-flex flex-column flex-md-row align-items-center justify-content-between py-3 small"
  >
    <p class="text-muted mb-1 mb-md-0">
      Copyright © 2022
      <a href="http://www.ellfsrl.it/" target="_blank">ELLF</a>.
    </p>
    <p class="text-muted">Versione {{ getVersion() }}</p>
  </div>
</footer>
